export default {
    /**
     * Datos añadidos a data por el mixin:
     * - countriesOptions: array con paises
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            countriesOptions: []
        };
    },
    methods: {
        /**
         * Load country options
         */
        async loadCountriesOptions() {
            try {
                const { private_area } = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS')))));
                const countries_info = private_area.countries;
                const countriesWithLiterals = countries_info.map(x => {
                    return {
                        name: this.$t(`countries.${x.key_name}`),
                        key: x.key_name,
                        phone_prefix: x.phone_prefix,
                        has_crs: x.has_crs
                    };
                });

                // Buscamos el objeto que tiene el literal ESP para eliminarlo
                const espLiteral = countriesWithLiterals.find(x => x.key === 'ESP');
                const indexEspLiteral = countriesWithLiterals.indexOf(espLiteral);

                // Eliminamos ESP del array
                countriesWithLiterals.splice(indexEspLiteral, 1);

                // Ordenamos el array alfabéticamente
                await countriesWithLiterals.sort(this.compare);

                // Concatenación del objecto ESP con el resto de paises
                this.countriesOptions = [espLiteral].concat(countriesWithLiterals);
                this.$store.dispatch('countriesStore/setCountries', this.countriesOptions);
            } catch (error) {
                this.$toast.error('Error loadCountriesOptions', `Error loading country options: ${error}`);
            }
        },
        compare(a, b) {
            return a.name.localeCompare(b.name);
        }
    },
    /**
     *
     */
    created() {
        this.countriesOptions = this.$store.getters['countriesStore/getCountries'];
        if (!this.countriesOptions.length) {
            this.loadCountriesOptions();
        }
    }
};
